import { Component, OnInit } from '@angular/core';
import { UnityService } from 'src/app/services/unity.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GasTravel } from 'src/app/models/gas-travel';
import { Unity } from 'src/app/models/unity';
import { from } from 'rxjs';
import { filter, reduce, map } from 'rxjs/operators';

@Component({
  selector: 'app-proeco-report-all',
  templateUrl: './proeco-report-all.component.html',
  styleUrls: ['./proeco-report-all.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]
})
export class ProecoReportAllComponent implements OnInit {
  loading:boolean = false;
  data:any[] = [];
  date:Date = new Date();
  type:string = null;
  types:string[] = ['n/a', 'proeco', 't26', 'proeco celaya'];

  unity:number = 0;
  month:string = '';
  gases:GasTravel[] = [];

  totals:any[] = [0,0,0,0,0,0,0,0,0,0,0,0,0];
  totalTotalXD:number = 0;
  totalGas:number = 0;
  gasType:string = null;
  expand:boolean = false;

  constructor( private unityServ:UnityService, private utl:UtilitiesService, private modal:NgbModal ) { }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.totals = [0,0,0,0,0,0,0,0,0,0,0,0,0];
    this.totalTotalXD = 0;

    this.unityServ.getProecoReport(this.date.getFullYear() + "", this.type, this.gasType)
      .then(resp => {
        this.data = resp;
        this.loading = false;

        for (const key in this.data) {
          const el = this.data[key].data;
          this.totalTotalXD += this.data[key].total;
          this.totals[0] += el.Enero ? el.Enero : 0;
          this.totals[1] += el.Febrero ? el.Febrero : 0;
          this.totals[2] += el.Marzo ? el.Marzo : 0;
          this.totals[3] += el.Abril ? el.Abril : 0;
          this.totals[4] += el.Mayo ? el.Mayo : 0;
          this.totals[5] += el.Junio ? el.Junio : 0;
          this.totals[6] += el.Julio ? el.Julio : 0;
          this.totals[7] += el.Agosto ? el.Agosto : 0;
          this.totals[8] += el.Septiembre ? el.Septiembre : 0;
          this.totals[9] += el.Octubre ? el.Octubre : 0;
          this.totals[10] += el.Noviembre ? el.Noviembre : 0;
          this.totals[11] += el.Diciembre ? el.Diciembre : 0;
        }
      }).catch(e => {
        this.utl.formatMessages(e);
        this.loading = false;
      });
  }

  openDetail (modal, month, monthStr, unity) {
    let u = new Unity();
    u.id = unity;
    let date1 = new Date(2020, month, 1);
    let date2 = new Date(2020, month + 1, 0);

    this.unity = unity;
    this.month = monthStr;

    this.loading = true;
    this.totalGas = 0;
    this.gases = [];

    this.unityServ.getGasTravel(u, date1, date2)
      .then(data => {
        from(data)
          .pipe(filter(x => {
            if (this.type != null && this.gasType != null) {
              return x.type == this.type && x.gas_type == this.gasType;
            } else if (this.type != null) {
              return x.type == this.type;
            } else if (this.gasType != null) {
              return x.gas_type == this.gasType;
            } else {
              return true;
            }
          }))
          .subscribe(x => {
            this.gases.push(x); 
            this.totalGas += Number(x.metric_real);
          }, null, () => this.loading = false);
      });

    this.modal.open(modal);
  }
}
